export default __webpack_public_path__ + "static/media/waiveoff-descicon.f3eb07fe.svg";